// Initialize Google Analytics

import ReactGA from 'react-ga'
import { GOOGLE_TRACKING_ID, IS_PRODUCTION } from 'utils/constants'
import firebase from 'firebase/app'
import 'firebase/analytics'

const initGA = history => {
  ReactGA.initialize(GOOGLE_TRACKING_ID)
  history.listen(location => {
    ReactGA.set({ page: location.pathname })
    ReactGA.pageview(window.location.pathname + window.location.search)
  })
}

const firebaseDevConfig = {
  apiKey: 'AIzaSyAdjipyUIdO85_vcu0M4rsRTSJlRobULCc',
  authDomain: 'ventureanalytics-210113.firebaseapp.com',
  databaseURL: 'https://ventureanalytics-210113.firebaseio.com',
  projectId: 'ventureanalytics-210113',
  storageBucket: 'ventureanalytics-210113.appspot.com',
  messagingSenderId: '59469378706',
  appId: '1:59469378706:web:d9d4d01b131764ebfba24b',
  measurementId: 'G-7RLZJWPDPP',
}

const firebaseProdConfig = {
  apiKey: 'AIzaSyAdjipyUIdO85_vcu0M4rsRTSJlRobULCc',
  authDomain: 'ventureanalytics-210113.firebaseapp.com',
  databaseURL: 'https://ventureanalytics-210113.firebaseio.com',
  projectId: 'ventureanalytics-210113',
  storageBucket: 'ventureanalytics-210113.appspot.com',
  messagingSenderId: '59469378706',
  appId: '1:59469378706:web:ddea78bb13f61203fba24b',
  measurementId: 'G-V4Z1E4D29W',
}

const initFirebase = history => {
  firebase.initializeApp(IS_PRODUCTION ? firebaseProdConfig : firebaseDevConfig)
  const firebaseAnalytics = firebase.analytics()
  history.listen(location => {
    firebaseAnalytics.setCurrentScreen(location)
  })

  return firebaseAnalytics
}

export { initGA, initFirebase }
